import * as React from "react";
import styles from './paymentSeals.module.scss'

const MaestroCard = 'https://res.cloudinary.com/albin-groen/image/upload/f_auto/v1585245981/ceroface/maestro-card.png'
const MasterCard = "https://res.cloudinary.com/albin-groen/image/upload/f_auto/v1585245980/ceroface/master-card.png";
const VisaCard = "https://res.cloudinary.com/albin-groen/image/upload/f_auto/v1585245980/ceroface/visa-card.png";
const Paypal = "https://res.cloudinary.com/albin-groen/image/upload/f_auto/v1585245980/ceroface/paypal-payment.png";

const PaymentSeals = () => {
  const paymentMethods = [
    {
      src: MasterCard,
      alt: "Mastercard"
    },
    {
      src: MaestroCard,
      alt: "Maestro card"
    },
    {
      src: VisaCard,
      alt: "Visa card"
    },
    {
      src: Paypal,
      alt: "Paypal"
    }
  ];

  return (
    <div className={styles.paymentMethods}>
      {paymentMethods.map(image => (
        <img key={image.alt} src={image.src} alt={image.alt} />
      ))}
    </div>
  );
};

export default PaymentSeals;
